import { CheckCircle2, GitBranch } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useOnboardingActions } from "@/hooks/queries/use-onboarding";

/**
 * Onboarding for an organization admin: connect the company's GitHub through
 * the CompBox app, so projects can pick or create their repositories.
 */
export function GitHubSetupStep({ organizationName, installUrl }: { organizationName: string; installUrl: string }) {
  const actions = useOnboardingActions();
  return (
    <div className="space-y-6">
      <div className="space-y-2 text-center">
        <h1 className="text-3xl font-semibold tracking-tight text-foreground">Connect GitHub</h1>
        <p className="text-sm text-muted-foreground">
          Let {organizationName}'s projects use your GitHub repositories.
        </p>
      </div>
      <ul className="space-y-2 text-sm text-muted-foreground">
        {[
          "Pick an existing repository for each project, or create a new one.",
          "Builds end as pull requests that CompBox opens for you.",
          "You choose which repositories CompBox can use. Access is short-lived, and no passwords or tokens are stored.",
        ].map((line) => (
          <li key={line} className="flex gap-2">
            <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
            <span>{line}</span>
          </li>
        ))}
      </ul>
      <div className="flex flex-col gap-2">
        <Button asChild>
          <a href={installUrl}>
            <GitBranch className="mr-2 h-4 w-4" />
            Connect GitHub
          </a>
        </Button>
        <Button
          variant="ghost"
          size="sm"
          disabled={actions.completeGitHubSetup.isPending}
          onClick={() => { actions.completeGitHubSetup.mutate(); }}
        >
          Skip for now
        </Button>
        <p className="text-center text-xs text-muted-foreground">You can connect it later in Settings → GitHub.</p>
      </div>
    </div>
  );
}
